// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_c7-b";
export var colorBlue = "_c7-8";
export var colorDot = "_c7-0";
export var colorDotLarge = "_c7-2";
export var colorDotSmall = "_c7-1";
export var colorGreen = "_c7-7";
export var colorGrey = "_c7-3";
export var colorOrange = "_c7-5";
export var colorPink = "_c7-a";
export var colorPurple = "_c7-9";
export var colorRed = "_c7-4";
export var colorYellow = "_c7-6";